module.exports = __webpack_public_path__ + "static/image1-e414293e53a1ce1bc0052e0f92a48169.jpg";